export default "__VITE_ASSET__C$u_fPEj__"